import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=46df217e&scoped=true&"
import script from "./detalle.vue?vue&type=script&lang=ts&"
export * from "./detalle.vue?vue&type=script&lang=ts&"
import style0 from "./detalle.vue?vue&type=style&index=0&id=46df217e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df217e",
  null
  
)

export default component.exports